import * as React from 'react';

import { cn } from '@/lib/utils';

export interface SectionProps extends React.HTMLAttributes<HTMLDivElement> {
    containerClassName?: string;
    'data-test-id'?: string;
}

const Section = React.forwardRef<HTMLDivElement, SectionProps>(
    ({ containerClassName, className, children, ...props }, ref) => (
        <section
            className={cn(
                'w-full scroll-mt-8 overflow-hidden px-6 py-8 md:scroll-mt-12 md:px-8 md:py-12 xl:py-16',
                className,
            )}
            ref={ref}
            {...props}
        >
            <div className={cn('container', containerClassName)}>
                {children}
            </div>
        </section>
    ),
);

export default Section;
